import React from 'react';

import { ChangeHandler } from 'src/presentation/components/pages/integrations/types';
import CompactSection from 'src/presentation/components/pages/integrations/editorComponents/CompactSection';
import { Row } from 'src/presentation/components/forms/Layout';
import {
  WrappedField,
  MaskedField,
} from 'src/presentation/components/pages/integrations/editorComponents/EditorFields';

function renderOrdergrooveConfiguration(
  onChange: (attr: string) => ChangeHandler,
  maskedFields: string[] = []
): JSX.Element {
  return (
    <>
      <CompactSection
        description={`The Ordergroove app enriches your customer pages with customer details and subscription information pulled from your Ordergroove instance.`}
      >
        <Row>
          <WrappedField
            attr="name"
            label="Name"
            placeholder="App Name"
            description="This is the name that will be displayed throughout Gladly"
            data-aid="ordergroove-integration-name"
            autoFocus={true}
            onChange={onChange('name')}
          />
        </Row>
        <Row>
          <WrappedField
            attr="connectionSettings.publicId"
            label="Ordergroove Merchant ID"
            description="This is the unique id of your shop in Ordergroove system"
            data-aid="ordergroove-public-id"
            onChange={onChange('connectionSettings.publicId')}
          />
        </Row>
        <Row>
          <MaskedField
            attr="secrets.hashKey"
            label="Storefront API Key (previously known as Hash Key)"
            description="This field is used to authenticate Ordergroove requests"
            data-aid="ordergroove-hash-key"
            onChange={onChange('secrets.hashKey')}
            showClearButton={maskedFields.includes('hashKey')}
            isMasked={maskedFields.includes('hashKey')}
          />
        </Row>
        <Row>
          <WrappedField
            attr="connectionSettings.apiUser"
            label="Ordergroove API User"
            description="This is the id of the Ordergroove user which will be used to perform requests"
            data-aid="ordergroove-api-user"
            onChange={onChange('connectionSettings.apiUser')}
          />
        </Row>
        <Row>
          <MaskedField
            attr="secrets.apiUserToken"
            label="API User Hash (previously known as API User Token)"
            description="This is the token for Ordergroove API user"
            data-aid="ordergroove-api-user-token"
            onChange={onChange('secrets.apiUserToken')}
            showClearButton={maskedFields.includes('apiUserToken')}
            isMasked={maskedFields.includes('apiUserToken')}
          />
        </Row>
        {/*
        Below row is present only in case we need to switch off ordergrooveApiKey feature flag. 
        In that case if apiKey is not shown in the UI it will be confusing to why the form validates without any fields being present.
        Since if apiKey is present connector-service will prioritize apiKey auth it should be possible to clear this field in case something goes wrong.
        */}
        {maskedFields.includes('apiToken') && (
          <Row>
            <MaskedField
              attr="secrets.apiToken"
              label="API Token"
              description="This is the Ordergroove API token"
              data-aid="ordergroove-api-token"
              onChange={onChange('secrets.apiToken')}
              showClearButton={maskedFields.includes('apiToken')}
              isMasked={maskedFields.includes('apiToken')}
            />
          </Row>
        )}
      </CompactSection>
    </>
  );
}

export default renderOrdergrooveConfiguration;
